import { Box } from '@mui/material';
import { Form, Select } from 'antd';
import InputForm from '../../InputT';

const { Option } = Select;

function Tab1(props: { form?: any }) {
  return (
    <div className="tabItemAuto">
      <Box display="flex" fontStyle="inherit" className="border" width="85%" position="absolute">

        {/* ── Colonne 1 : Identification ─────────────────────────── */}
        <Box fontStyle="inherit" className="border-left">

          {/* Code */}
          <InputForm

            label="Code"
            name="Code"
            type="text"
            error="Veuillez saisir le code"
          />

          {/* Libellé */}
          <InputForm

            label="Libellé"
            name="Libelle"
            type="text"
            error="Veuillez saisir le libellé"
          />

        </Box>

        {/* ── Colonne 2 : Paramètres ─────────────────────────────── */}
        <Box fontStyle="inherit" className="border-left">

          {/* Statut Actif */}
          <Box margin={1} fontStyle="inherit">

            {/* Type Valeur */}
            <InputForm

              label="Type Valeur"
              name="TypeValeur"
              type="text"
              error="Veuillez saisir le type de valeur"
            />
            <Form.Item
              label="Statut"
              name="ISActif"
              rules={[{ required: true, message: 'Veuillez sélectionner le statut' }]}
              labelCol={{ span: 9 }}
            >
              <Select size="middle" style={{ width: '100%' }}>
                <Option value="1">Actif</Option>
                <Option value="0">Inactif</Option>
              </Select>
            </Form.Item>
          </Box>

        </Box>

        <Box margin={1} fontStyle="inherit">
          {/* Valeur par défaut */}
          <InputForm
            label="Valeur par défaut"
            name="DefaultValue"
            type="number"
            error="Veuillez saisir la valeur par défaut"
          />
          {/* Valeur */}
          <InputForm
            label="Valeur"
            name="Valeur"
            type="number"
            error="Veuillez saisir la valeur de la coupure"
          />
        </Box>

      </Box>
    </div>
  );
}

export default Tab1;